// The back-ratings URL. REACT_APP_API_URL is read at build time by Create
// React App (a .env.local for a staging back, nothing for production); the
// default is the production service, so the Cloud Run build needs no variable.
export const API_DEFAULT =
  process.env.REACT_APP_API_URL || "https://back-ratings-service-q2nhgfzuoq-uc.a.run.app";
